import { getFormatMessage } from '@/utils/utils'
import { Modal, Space, Table } from 'antd'
import React from 'react'
import { TemplateReferenceItem, TemplateReferenceProps } from '../interface'

export const TemplateReference: React.FC<TemplateReferenceProps> = (
  props: TemplateReferenceProps
) => {
  const { data, visible, onVisibleChange, onRefRelease } = props
  const formatMessage = getFormatMessage()

  const columns = [
    {
      title: formatMessage({ id: 'app.template.reference.objectType' }),
      key: 'app.template.reference.objectType',
      render: (text: any, record: TemplateReferenceItem, index: any) => {
        return formatMessage({
          id: `app.template.reference.objectType.${record.objectType}`
        })
      }
    },
    {
      title: '引用计数',
      key: 'app.template.reference.objectIds',
      render: (text: any, record: TemplateReferenceItem, index: any) => {
        return record.objectIds?.length
      }
    },
    {
      title: '操作',
      key: 'app.template.reference.operation',
      render: (text: any, record: TemplateReferenceItem, index: any) => (
        <Space size='middle'>
          <a onClick={() => handleRelease(record)}>
            {formatMessage({ id: '解除' })}
          </a>
        </Space>
      )
    }
  ]

  const handleRelease = (record: TemplateReferenceItem) => {
    Modal.confirm({
      title: '系统提示',
      content: '此操作会删除所有引用对象，此过程不可恢复，确定要解除当前引用？',
      okText: formatMessage({ id: 'app.modal.ok' }),
      cancelText: formatMessage({ id: 'app.modal.cancel' }),
      onOk() {
        onRefRelease?.(record)
      }
    })
  }

  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      visible={visible}
      footer={null}
      title='引用列表'
      onCancel={() => onVisibleChange?.(false)}
    >
      <Table rowKey='objectType' columns={columns} dataSource={data} />
    </Modal>
  )
}
